import React from 'react';
import { Alert, Timeline } from 'antd';

// Cronologia (audit-log order_event_logs) dei preventivi cliente/fornitore.
// Stesso pattern della tab "Cronologia" dei modal Visualizza degli ordini.
const EVENT_LABELS: { [key: string]: string } = {
  CREATE: 'Preventivo creato',
  UPDATE: 'Modifica',
  STATUS_CHANGE: 'Cambio stato',
  DELETE: 'Eliminazione',
  PRODUCT_ADDED: 'Prodotto aggiunto',
  PRODUCT_REMOVED: 'Prodotto rimosso',
  PRODUCT_MODIFIED: 'Prodotto modificato',
  CONVERT: 'Conversione in ordine',
};

export const getQuoteEventLabel = (eventType: string) => EVENT_LABELS[eventType] || eventType;

export const getQuoteEventColor = (eventType: string) => {
  if (['CREATE', 'PRODUCT_ADDED'].includes(eventType)) return 'green';
  if (['DELETE', 'PRODUCT_REMOVED'].includes(eventType)) return 'red';
  if (['STATUS_CHANGE', 'CONVERT'].includes(eventType)) return 'blue';
  return 'gray';
};

interface QuoteHistoryTimelineProps {
  events: any[];
  emptyText?: string;
}

const QuoteHistoryTimeline: React.FC<QuoteHistoryTimelineProps> = ({
  events,
  emptyText = 'Nessuna operazione registrata per questo preventivo',
}) => {
  if (!events || events.length === 0) {
    return <Alert message={emptyText} type="info" />;
  }
  return (
    <Timeline>
      {events.map((event, index) => (
        <Timeline.Item key={event.id ?? index} color={getQuoteEventColor(event.event_type)}>
          <div>
            <strong>{getQuoteEventLabel(event.event_type)}</strong>
            <div style={{ fontSize: '12px', color: '#666' }}>
              {new Date(event.created_at).toLocaleString()}
            </div>
            {event.description && <div style={{ marginTop: 4 }}>{event.description}</div>}
            {event.user && (
              <div style={{ fontSize: '12px', color: '#999' }}>da {event.user.username}</div>
            )}
          </div>
        </Timeline.Item>
      ))}
    </Timeline>
  );
};

export default QuoteHistoryTimeline;
